<div class="d-flex justify-content-between align-items-start mb-4">
  <div>
    <h1 class="h2 mb-1 fw-bold">New Work Order</h1>
    <p class="text-muted mb-0">Schedule a job and assign it to one of your pilots.</p>
  </div>
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
    <i class="bi bi-x-lg me-2"></i>Cancel
  </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="mb-0">Details</h5>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12">
          <label class="form-label">Title<span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="title"
                 placeholder="e.g. South 40 — corn fungicide pass"
                 [class.is-invalid]="hasError('title', 'required') || hasError('title', 'minlength')">
          <div class="invalid-feedback" *ngIf="hasError('title', 'required')">
            Title is required.
          </div>
          <div class="invalid-feedback" *ngIf="hasError('title', 'minlength')">
            Title must be at least 2 characters.
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Customer</label>
          <select class="form-select" formControlName="customerId">
            <option value="">No customer</option>
            <option *ngFor="let c of customers()" [value]="c.id">{{ c.name }}</option>
          </select>
          <div class="form-text">
            <a routerLink="/customers/add" class="text-decoration-none">
              <i class="bi bi-plus-lg"></i> Create new customer
            </a>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Field</label>
          <select class="form-select" formControlName="fieldId">
            <option value="">No field</option>
            <option *ngFor="let f of fields()" [value]="f.id">{{ f.name }}</option>
          </select>
          <div class="form-text" *ngIf="form.value.customerId && fields().length === 0">
            This customer has no fields yet.
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Assigned pilot</label>
          <select class="form-select" formControlName="assignedPilotProfileId">
            <option value="">Unassigned</option>
            <option *ngFor="let p of assignablePilots()" [value]="p.id">{{ p.name }}</option>
          </select>
          <div class="form-text">
            Leaving this unset is fine — you can assign later from the work order detail.
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Scheduled date</label>
          <input type="date" class="form-control" formControlName="scheduledDate">
        </div>

        <div class="col-md-3">
          <label class="form-label">Scheduled time</label>
          <input type="text" class="form-control" formControlName="scheduledTime"
                 placeholder="e.g. Early morning, 9 AM">
        </div>

        <div class="col-12">
          <label class="form-label">Description</label>
          <textarea appCharCounter class="form-control" rows="4" formControlName="description"
                    placeholder="Anything the pilot should know going in — chemicals, special instructions, gate codes."></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="isSaving() || form.invalid">
      <span *ngIf="isSaving()" class="spinner-border spinner-border-sm me-2"></span>
      Create Work Order
    </button>
  </div>
</form>
